var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocateRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0002 18.9403C7.80533 18.9403 7.61047 18.9067 7.4156 18.8394C7.22073 18.7721 7.04445 18.6679 6.88675 18.5269C5.98933 17.7 5.1496 16.8484 4.36755 15.9721C3.5855 15.0958 2.90569 14.2199 2.32812 13.3442C1.75056 12.4686 1.29351 11.6006 0.956973 10.7404C0.620423 9.88011 0.452148 9.04933 0.452148 8.24805C0.452148 5.94038 1.19862 4.07213 2.69157 2.64328C4.18451 1.21443 5.95405 0.5 8.0002 0.5C10.0463 0.5 11.8159 1.21443 13.3088 2.64328C14.8018 4.07213 15.5482 5.94038 15.5482 8.24805C15.5482 9.04933 15.38 9.87851 15.0434 10.7356C14.7069 11.5926 14.2514 12.4606 13.6771 13.3394C13.1027 14.2183 12.4245 15.0942 11.6425 15.9673C10.8604 16.8404 10.0207 17.6903 9.12325 18.5173C8.96786 18.6583 8.79129 18.7641 8.59352 18.8346C8.39574 18.9051 8.19797 18.9403 8.0002 18.9403ZM8.0019 9.86535C8.49948 9.86535 8.92487 9.68818 9.27807 9.33385C9.63127 8.97952 9.80787 8.55356 9.80787 8.05598C9.80787 7.55839 9.63071 7.133 9.27637 6.7798C8.92204 6.4266 8.49608 6.25 7.9985 6.25C7.50092 6.25 7.07552 6.42717 6.72232 6.7815C6.36912 7.13583 6.19252 7.56179 6.19252 8.05938C6.19252 8.55696 6.36969 8.98235 6.72402 9.33555C7.07836 9.68875 7.50431 9.86535 8.0019 9.86535Z",
    fill: "#d64949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocateRedIcon);
export default __webpack_public_path__ + "static/media/locate_red_icon.99dc7f43c4267e0b02d1c696d413dfe3.svg";
export { ForwardRef as ReactComponent };